.page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--background);
}

.main {
  flex: 1;
  padding-bottom: 64px;
}

.main.flush {
  padding-bottom: 0;
}

/* Page `underHeader`: the header's band and the hero share a grid, so the
   hero's photo and veil (absolutely placed, inset: 0) fill the band too, under
   the transparent header, whatever its height (the nav wraps below 1280 px).
   Rows: 1 the header, 2 the hero's content, 3 the rest of <main>, 4 the footer.
   <main> starts on the header's row and passes the rows down (subgrid) to the
   hero, which spans rows 1–2 and puts its content in row 2. The header stays
   outside <main>, and above it (z-index 10 against the hero's 2). */
/* flex: none — .page is a flex item of the root view, which shrinks it to the
   viewport's height (its content overflows; in the flex column that is
   harmless, the footer has flex: none). A grid that short would squeeze its
   last row — the footer's — to 0, so it keeps its content's height. */
.pageUnder {
  flex: none;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto auto auto auto;
}

.pageUnder > :first-child {
  grid-row: 1;
  grid-column: 1;
}

/* By tag: SiteFooter also renders the hidden data-lastmod-skip sentinels
   around <footer>, so it is not the last child. */
.pageUnder > footer {
  grid-row: 4;
  grid-column: 1;
}

.mainUnder {
  grid-row: 1 / 4;
  grid-column: 1;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: subgrid;
}

.mainUnder > :first-child {
  grid-row: 1 / 3;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: subgrid;
  /* Phones: the hero's top veil, sized to the hero, would end above the lead
     once the hero also holds the header's band; push it down by about that band. */
  --hero-veil-extend: 14%;
}

/* Not the photo: an absolutely placed grid child given a row would be
   confined to it. width: 100% — as a grid item its auto side margins would
   shrink it to its content and centre it; with it, max-width + margin: 0 auto
   centre the container as in block layout. */
.mainUnder > :first-child > :not(img) {
  grid-row: 2;
  width: 100%;
}

.mainUnder > :last-child {
  grid-row: 3;
}

.intro {
  margin: -6px 0 26px;
  max-width: 720px;
  font-size: 16px;
  line-height: 1.6;
  color: var(--text-secondary);
}

@media (min-width: 1024px) {
  .main {
    padding-bottom: 80px;
  }
}
